import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { UserMultiple } from "@carbon/icons-react";
import { Button, Loader } from "../../components";
import Delegate from "../../components/Material/Delegate/Delegate";
import {
  useMaterialsByOwner,
  useRetrieveAllMaterials,
} from "../../hooks/useMaterials";
import { useNotification } from "../../context";
import { MaterialType } from "../../types";

const DelegateCnt = () => {
  const { openNotification } = useNotification();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: materialsByOwner, isLoading: isLoadingMaterials } =
    useMaterialsByOwner(MaterialType.DIRECT_GOODS, 0);

  const { mutate: retrieveMaterials, isPending: isGettingBackMaterials } =
    useRetrieveAllMaterials(
      () => {
        openNotification(t("materials.success"));
        return navigate(`/materials`);
      },
      () => openNotification(t("newMaterialForm.error"))
    );

  return (
    <div>
      <div className="flex items-center justify-between pb-4">
        <h2 className="text-xl font-bold leading-7 text-gray-900 sm:truncate uppercase">
          {t("delegate.material")}
        </h2>
        {materialsByOwner && materialsByOwner?.content?.length > 0 && (
          <Button
            type="button"
            onClick={() => retrieveMaterials()}
            disabled={isGettingBackMaterials}
          >
            <UserMultiple size={16} />
            <span>{t("materials.retrieve")}</span>
          </Button>
        )}
      </div>
      {isLoadingMaterials || isGettingBackMaterials ? (
        <Loader isFullScreen />
      ) : (
        <Delegate isDelegateAll />
      )}
    </div>
  );
};

export default DelegateCnt;
